import { graphql } from 'react-relay';

export const logoBlockFragment = graphql`
    fragment LogoBlock_contentBlock on LogoBlock {
        logoUrl
        logoAltText
        captionTitle
        captionText
        isQuote
    }
`;
